export default __webpack_public_path__ + "static/get-info-f6d840ac3b34dc0dd400a81a295b1687.png";